const init = (app) => {
  app.store.pendingExchangesCount = []
  app.store.loadNotApprovedExchanges = () => {
  let successCallback = (response) => {
    app.store.pendingExchangesCount = response.body.data.count
    app.$emit('updatePendingExchangesCount', app.store.pendingExchangesCount)
  }

  let errorCallback = (response) => {
    if (response.status === 401) {
      console.log('not_authorized')
    } else {
      console.log('error:', response)
    }
  }

  const admin = app.$cookies.isKey('admin') && app.$cookies.get('admin') === 'true'
  if (!admin) return false

  const token = app.$cookies.get('api_token')
  app.$http.get(app.urls.admin_exchanges_pending_count, {headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
  }
  app.store.loadNotApprovedExchanges()
  setInterval(() => { app.store.loadNotApprovedExchanges() }, 1000 * 60)
}

export default {
  init
}



// WEBPACK FOOTER //
// ./src/stores/Exchanges.js